const orderSchema = [
    {
      name: 'order_type',
      label: 'Order Type',
      type: 'select',
      required: true,
      placeholder: 'Select Order Type',
      disabled: false,
      options: ['Sale', 'Purchase'],
    },
    {
      name: 'order_date',
      label: 'Order Date',
      type: 'date',
      required: true,
      placeholder: '',
      disabled: false,
    },
    {
      name: 'delivery_date',
      label: 'Delivery Date',
      type: 'date',
      required: false,
      placeholder: '',
      disabled: false,
    },
    {
      name: 'customer_id',
      label: 'Customer',
      type: 'customer-select',
      required: false,
      placeholder: 'Select Customer',
      disabled: false,
      conditional: {
        field: 'order_type',
        value: 'Sale',
      },
    },
    {
      name: 'supplier_id',
      label: 'Supplier',
      type: 'supplier-select',
      required: false,
      placeholder: 'Select Supplier',
      disabled: false,
      conditional: {
        field: 'order_type',
        value: 'Purchase'
      }
    },
    {
      name: 'order_status',
      label: 'Order Status',
      type: 'select',
      required: true,
      placeholder: 'Select Order Status',
      disabled: false,
      options: [
        'Pending',
        // 'Confirmed',
        // 'In Transit',
        // 'Delivered',
        'Completed',
        'Work in Progress',
        // WIP should reduce inventory
        // 'Cancelled',
        // 'Returned',
        // 'Return In Transit',
      ],
    },
    {
      name: 'payment_status',
      label: 'Payment Status',
      type: 'select',
      required: false,
      placeholder: 'Select Payment Status',
      disabled: false,
      options: ['Paid', 'Pending', 'Overdue'],
    },
    {
      name: 'tracking_info',
      label: 'Tracking Information',
      type: 'text',
      required: false,
      placeholder: 'Enter tracking information',
      disabled: false,
    },
    {
      name: 'product_line_items',
      label: 'Product Line Items',
      type: 'product-line-items',
      required: true,
      placeholder: '',
      disabled: false,
    },
    {
      name: 'tax_percentage',
      label: 'Tax Percentage',
      type: 'tax-percentage-lookup',
      required: false,
      placeholder: 'Enter tax percentage (leave blank for 0%)',
      validation: {
        min: 0,
        max: 100
      }
    }
  ];
  
  export default orderSchema;
